
<!--该课程还没有开放，课程进入没有内容显示此页面-->
<template>
  <div class="box">

<!--    <div @click="back">-->
<!--      <img src="../assets/back4.png" class="turn" style="  position: fixed;left: 0px;top: 0px;width: 80px;height:80px;z-index:9999; " id="musicStopIco">-->
<!--    </div>-->
  </div>
</template>

<script>
  export default {
    name: "NoOrder",
    methods:{
      //返回
      back(){
        this.$router.back();
      },
    }
  }
</script>

<style scoped>
  .box{
    background-image: url("../assets/noOrder.png");
    width: 70%;
    height: 70%;
    background-size: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/NoOrder.vue